import store from '../../store/index';

const userTypes = {
  1: 'Fund',
  2: 'Investor',
  3: 'Service Provider',
  4: 'iConnections',
  5: 'Speaker',
  6: 'Guest',
  7: 'Media',
  8: 'Other',
  9: 'NFT',
  10: 'Student/Retired',
};

let enrichedInfo;

const init = (userInfo) => {
  // Enrich this object with anything else we want to store
  enrichedInfo = {
    userType: userTypes[userInfo.CompanyTypeID],
  };
};

const sendEvent = async (event, payload) => {
  try {
    const jwtToken = store.getters['main/token'];

    const url = `${process.env.BFFV2_BASE_URL}/users/track_frontend_events`;
    const data = JSON.stringify({
      jwtToken, event, ...enrichedInfo, ...payload,
    });

    await navigator.sendBeacon(url, new Blob([data], { type: 'application/json' }));
  } catch (e) {
    console.error('Failed to track the event', e);
  }
};

export default {
  sendEvent,
  init,
};
